import axios from "axios";
import axiosRetry from "axios-retry";
import { localStorageGetItem, localStorageRemoveItem, localStorageSetItem } from "../App";

export const getAccessTokenFromStorage = () =>
  new Promise(async (resolve, reject) => {
    try {
      const value = localStorageGetItem("userToken");
      resolve(value);
    } catch (error) {
      console.warn(error);
    }
  });
export const setHeaders = async (headers = null) => {
  let headerData;
  return getAccessTokenFromStorage().then((token) => {
    headerData = {
      "Content-type": "application/json",

      "Accept": "application/json",
      ...(token && {
        Authorization: `Bearer ${token}`,
      }),
    };

    if (headers) {
      headerData = { ...headerData, ...headers };
    }

    return headerData;
  });
};

const createAxios = async () => {
  let headers = await setHeaders(); // This function should handle any async operations needed for setting headers.
  const axiosInstance = axios.create({
    baseURL: "https://production-api.virtuesshop.co",
    headers: headers,
  });

  axiosRetry(axiosInstance, {
    retries: 1, // Reduce retry attempts
    retryCondition: (error) => {
      // Only retry for certain network or idempotent errors
      return (
        axiosRetry.isNetworkOrIdempotentRequestError(error) ||
        error.code === "ECONNABORTED" ||
        error.message.includes("Network Error") ||
        (error.response && [502, 503, 504].includes(error.response.status))
      );
    },
    retryDelay: (retryCount) => {
      // Custom retry delay, for example, 1000ms for the first retry, 2000ms for the second, etc.
      return retryCount * 1000; // 1s, 2s, etc.
    },
  });
  return axiosInstance;
};

export default createAxios;
